import { render, staticRenderFns } from "./ChecksOverview.vue?vue&type=template&id=722d30be&scoped=true&"
import script from "./ChecksOverview.vue?vue&type=script&lang=js&"
export * from "./ChecksOverview.vue?vue&type=script&lang=js&"
import style0 from "./ChecksOverview.vue?vue&type=style&index=0&id=722d30be&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "722d30be",
  null
  
)

export default component.exports